// File: components/DutyList/Filters.js
import React from "react";

const Filters = ({ filter, setFilter, setCurrentPage, doctorList }) => {
  return (
    <div className="row g-2 mb-4">
      <div className="col-md-3">
        <label className="form-label">Filter by Date</label>
        <input
          type="date"
          className="form-control"
          value={filter.date}
          onChange={(e) => {
            setFilter({ ...filter, date: e.target.value });
            setCurrentPage(1);
          }}
        />
      </div>
      <div className="col-md-3">
        <label className="form-label">Filter by Sections</label>
        <input
          type="text"
          className="form-control"
          placeholder="e.g. ER, OT"
          value={filter.section}
          onChange={(e) => {
            setFilter({ ...filter, section: e.target.value });
            setCurrentPage(1);
          }}
        />
      </div>
      <div className="col-md-3">
        <label className="form-label">Filter by Doctor</label>
        <select
          className="form-select"
          value={filter.name}
          onChange={(e) => {
            setFilter({ ...filter, name: e.target.value });
            setCurrentPage(1);
          }}
        >
          <option value="">All</option>
          {doctorList.map((name, i) => (
            <option key={i} value={name}>
              {name}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-3 d-flex align-items-end">
        <button
          className="btn btn-secondary w-100"
          onClick={() => setFilter({ date: "", section: "", name: "" })}
        >
          Reset Filters
        </button>
      </div>
    </div>
  );
};

export default Filters;
